function checkoutGuestLogin() {
    $(document).on('click', '#account-checkout-guest-button', function (e) {
        e.preventDefault();
        var $form = $(this).parents('#dwfrm_login'),
            $actionUrl = $form.attr('action');

        $.ajax({
            type: "POST",
            url: $actionUrl,
            data: $form.serialize(),
            success: function(data) {
                window.location = $actionUrl; 
            }
        });
    });
}

module.exports = {
    init: function () {
        checkoutGuestLogin();
    }
}